import { t } from '@lingui/macro';

import {
    Cloud,
    CompareArrows,
    DeviceHub,
    NetworkWifi,
    Room,
    Router,
    SettingsEthernet,
    SettingsRemote,
    Storage,
    WifiTethering,
} from '@material-ui/icons';
import { VmwareHypervisor, VmwareVm } from '../icon';

import {
    accessPointDetailPageId,
    agentDetailPageId,
    businessServiceDetailPageId,
    hypervisorDetailPageId,
    interfaceDetailPageId,
    networkDeviceDetailPageId,
    radioDetailPageId,
    serverDetailPageId,
    siteDetailPageId,
    testDetailPageId,
    virtualMachineDetailPageId,
    wirelessControllerDetailPageId,
} from '../pages';
import {
    accessPointFilterId,
    agentFilterId,
    businessServiceFilterId,
    hypervisorFilterId,
    interfaceFilterId,
    networkDeviceFilterId,
    radioFilterId,
    serverFilterId,
    siteFilterId,
    testFilterId,
    virtualMachineFilterId,
    wirelessControllerFilterId,
} from '../filters';

export const ROW_HEIGHT = 55;
export const DOUBLE_ROW_HEIGHT = ROW_HEIGHT * 2;
export const TWELVE_ROW_HEIGHT = ROW_HEIGHT * 12;

export const GLOBAL_SEARCH_TYPES = {
    server: {
        title: t`Servers`,
        icon: Storage,
        filterMapping: {
            [serverFilterId]: 'uuid',
        },
        link: {
            target: serverDetailPageId,
        },
    },
    agent: {
        title: t`nPoints`,
        icon: SettingsRemote,
        filterMapping: {
            [agentFilterId]: 'uuid',
        },
        link: {
            target: agentDetailPageId,
        },
    },
    test: {
        title: t`Service Tests`,
        icon: CompareArrows,
        filterMapping: {
            [testFilterId]: 'uuid',
        },
        link: {
            target: testDetailPageId,
        },
    },
    businessservice: {
        title: t`Business Services`,
        icon: Cloud,
        filterMapping: {
            [businessServiceFilterId]: 'uuid',
        },
        link: {
            target: businessServiceDetailPageId,
        },
    },
    device: {
        title: t`Network Devices`,
        icon: Router,
        filterMapping: {
            [networkDeviceFilterId]: 'uuid',
        },
        link: {
            target: networkDeviceDetailPageId,
        },
    },
    ssid: {
        title: t`SSIDs`,
        icon: NetworkWifi,
        filterMapping: {
            [radioFilterId]: 'uuid',
        },
        link: {
            target: radioDetailPageId,
        },
    },
    wirelesscontroller: {
        title: t`Wireless Controllers`,
        icon: DeviceHub,
        filterMapping: {
            [wirelessControllerFilterId]: 'uuid',
        },
        link: {
            target: wirelessControllerDetailPageId,
        },
    },
    accesspoint: {
        title: t`Access Points`,
        icon: Router,
        filterMapping: {
            [accessPointFilterId]: 'uuid',
        },
        link: {
            target: accessPointDetailPageId,
        },
    },
    radio: {
        title: t`Radios`,
        icon: WifiTethering,
        filterMapping: {
            [radioFilterId]: 'uuid',
        },
        link: {
            target: radioDetailPageId,
        },
    },
    interface: {
        title: t`Interfaces`,
        icon: SettingsEthernet,
        filterMapping: {
            [interfaceFilterId]: 'uuid',
        },
        link: {
            target: interfaceDetailPageId,
        },
    },
    site: {
        title: t`Sites`,
        icon: Room,
        filterMapping: {
            [siteFilterId]: 'uuid',
        },
        link: {
            target: siteDetailPageId,
        },
    },
    virtualmachine: {
        title: t`Virtual Machines`,
        icon: VmwareVm,
        filterMapping: {
            [virtualMachineFilterId]: 'uuid',
        },
        link: {
            target: virtualMachineDetailPageId,
        },
    },
    hypervisor: {
        title: t`Hypervisors`,
        icon: VmwareHypervisor,
        filterMapping: {
            [hypervisorFilterId]: 'uuid',
        },
        link: {
            target: hypervisorDetailPageId,
        },
    },
};
